import { Component, OnInit } from '@angular/core';
import { FormsService } from 'src/app/services/forms/forms.service';
import { LayoutListModel } from 'src/app/services/forms/layout-list-model';
import { MessageService } from 'src/app/services/message.service';
import { SubmenuService } from '../../submenu/submenu.service';

@Component({
  selector: 'app-layout-list',
  templateUrl: './layout-list.component.html',
  styleUrls: ['./layout-list.component.less']
})
export class LayoutListComponent implements OnInit {

  page:number = 1;
  componentData: LayoutListModel | undefined;
  
  constructor(public formsService: FormsService, public messageService:MessageService, public submenuService:SubmenuService) 
  { 
    
  }

  ngOnInit(): void {
    
    this.messageService.showLoading();
    this.formsService.loadLayoutsPage(this.page).subscribe((data:LayoutListModel) => {
        this.componentData = data;
        this.messageService.hideLoading();
    },    
    err => {
      this.messageService.hideLoading();
      this.messageService.showMessage(err.message, "error");
      console.log(err);
    });
  }

  ngAfterViewChecked(){
    this.submenuService.showRecordList("/layouts");    
  }

}
